// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"WishList_Wrapper__goWKA","LIstItemWrapper":"WishList_LIstItemWrapper__3BKZg"};